module.exports = __webpack_public_path__ + "static/media/bitdots-3.c3bc18cb.svg";